import { Post, PostExt } from "../types";

const transformPost = (post: Post): PostExt => {
  const reactionCount: number = post.reactions.reduce(
    (acc, curr) => acc + curr.count,
    0
  );

  const hasUserReacted = post.reactions.some(
    (reaction) => reaction.current_user_reacted
  );

  return { ...post, likes: reactionCount, is_liked: hasUserReacted }; // adding reaction count to likes to make number match between app & web
};

export default transformPost;
